// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__zWTAq","content":"GlobalSearch_content__3CwQ_"};